import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=ed310d92&"
import script from "./OrderEdit.vue?vue&type=script&lang=ts&"
export * from "./OrderEdit.vue?vue&type=script&lang=ts&"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=ed310d92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports